// extracted by mini-css-extract-plugin
module.exports = {"content":"Ub2ZoJIM"};